import React from 'react';
import { SettingsHeader as SettingsHeaderComponent } from '../../../Data/partials';

export default function SettingsHeader() {
	return <SettingsHeaderComponent hideShareButton={true} isEmbed={true} />;
}
